import { render } from "./InThePressInner.vue?vue&type=template&id=271d8bc6"
import script from "./InThePressInner.vue?vue&type=script&lang=js"
export * from "./InThePressInner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__